<template>
  <div>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-5" flat>
              <v-icon>mdi-format-align-justify</v-icon>
              <v-toolbar-title class="toolbar-title-3">{{ labels.mainTitle }}</v-toolbar-title>
            </v-toolbar>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed @click.prevent="doExpandAll">
                <span class="btn-normal-error">{{ labels.expandAll }}</span>
                <v-icon dark right>mdi-plus</v-icon>
              </v-btn>
              <v-btn depressed @click.prevent="doCollapseAll">
                <span class="btn-normal-primary">{{ labels.collapseAll }}</span>
                <v-icon dark right>mdi-minus</v-icon>
              </v-btn>
            </v-card-actions>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table
                      :headers="headers"
                      :items="itemList"
                      class="elevation-1"
                      :loading="loading"
                      item-key="risk"
                      :single-expand="singleExpand"
                      :expanded.sync="expanded"
                      show-expand
                    >
                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                          <v-flex xs12>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex lg1 xs12> </v-flex>
                                <v-flex lg1 xs12>
                                  <pre><span style="font-family: Arial; font-size: 14px">{{ item.itemDesc1}}</span></pre>
                                </v-flex>
                                <v-flex lg3 xs12>
                                  <pre><span style="font-family: Arial; font-size: 14px">{{ item.itemDesc2}}</span></pre>
                                </v-flex>
                                <v-flex lg1 xs12 class="text-right">
                                  <pre><span style="font-family: Arial; font-size: 14px">{{ item.itemDesc3}}</span></pre>
                                </v-flex>
                                <!-- <v-flex lg1 xs12> </v-flex> -->
                                <v-flex lg2 xs12>
                                  <pre><span style="font-family: Arial; font-size: 14px">{{ item.itemDesc4}}</span></pre>
                                </v-flex>
                                <v-flex lg2 xs12 class="text-right">
                                  <pre><span style="font-family: Arial; font-size: 14px">{{ item.itemDesc5}}</span></pre>
                                </v-flex>

                              </v-layout>
                            </v-container>
                          </v-flex>
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <QueryPolicyTotals ref="queryPolicyTotals"></QueryPolicyTotals>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-settings</v-icon><span class="headerTitle">Additional Settings</span></div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <QueryAdditionalSettings ref="queryAdditionalSettings"></QueryAdditionalSettings>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-cash</v-icon><span class="headerTitle">{{ labels.siTotalTitle }}</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <QuerySumInsuredTotals ref="querySumInsuredTotals"></QuerySumInsuredTotals>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <ButtonPrintSchedule
            labelName="Print Schedule"
            :polNo="polMaster.polNo"
            :renCnt="polMaster.renCnt"
            :endtCnt="polMaster.endtCnt"
            :tranRel="polMaster.tranRel"
            :schedForm="polMaster.schedForm"
          ></ButtonPrintSchedule>
        </v-flex>
        <!--  -->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import QueryPolicyTotals from './QueryPolicyTotals'
import QueryAdditionalSettings from './QueryAdditionalSettings'
import QuerySumInsuredTotals from './QuerySumInsuredTotals'
import { formatYesNo } from '@/utils/boolean'
import { listPolicyMixin } from '../../listPolicyMixin'
import ButtonPrintSchedule from '@/components/core/common/button/ButtonPrintSchedule.vue'
export default {
  data() {
    return {
      showExpandAddtl: false,
      showExpandSITotal: false,
      labels: {
        mainTitle: 'Policy Summary',
        expandAll: 'Expand All',
        collapseAll: 'Collapse All',
        printDraft: 'Print Draft',
        siTotalTitle: 'Sum Insured Totals'
      },
      mainForm: {},
      loading: false,
      headers: [
        { text: 'Risk', value: 'risk' },
        { text: 'Class', value: 'busCls' },
        { text: 'GAP', value: 'totGap' },
        { text: 'PD', value: 'premDue' },
        { text: 'Discount', value: 'disc' },
        { text: 'Comm 1/2/3', value: 'totComm' },
        { text: 'S/F/T', value: 'totSFT' },
        { text: 'Apply GST', value: 'applyGst' },
        { text: 'GST Amount', value: 'premGst' },
        { text: 'Payable', value: 'payable' }
      ],
      itemList: [],
      expanded: [],
      showErrorDialog: false,
      policy: {
        loading: false,
        saving: false
      },
      reportMenu: {},
      polTypeAppId: undefined,
      printError: false,
      singleExpand: true
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    displayErrorDialog() {
      return this.messages
    },
    rptMenu_uw() {
      return this.$store.state.reports.uwReports.menu
    },
    rptMenu_sched() {
      return this.$store.state.reports.scheduleReports.menu
    }
  },
  methods: {
    async doInit() {
      await this.getPolSummaryList().then(() => {
        if (this.$refs.queryPolicyTotals !== undefined) {
          this.$refs.queryPolicyTotals.doInit()
        }
        if (this.$refs.queryAdditionalSettings !== undefined) {
          this.$refs.queryAdditionalSettings.doInit()
        }
        if (this.$refs.querySumInsuredTotals !== undefined) {
          this.$refs.querySumInsuredTotals.doInit().then(() => {
            this.labels.siTotalTitle = this.$refs.querySumInsuredTotals.labels.title
          })
        }
      })
    },
    async getPolSummaryList() {
      const apiUrl = this.$store.state.underwriting.policySummarySettings.menu.querySummaryList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          this.displayList(result).then(() => {
            this.loading = false
          })
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async displayList(result) {
      const { data } = result
      if (data) {
        this.itemList = []
        data.data.map((item) => {
          const convertItem = {
            polNo: item.polNo,
            renCnt: item.renCnt,
            endtCnt: item.endtCnt,
            riskGrpNo: item.riskGrpNo,
            riskNo: item.riskNo,
            risk: item.riskGrpNo.toString().padStart(2, '0') + '/' + item.riskNo.toString().padStart(3, '0'),
            busCls: item.busCls,
            totGap: item.totGap.toFixed(2),
            premDue: item.premDue.toFixed(2),
            disc: item.disc.toFixed(2),
            totComm: item.totComm.toFixed(2),
            comm1: item.comm1.toFixed(2),
            comm2: item.comm2.toFixed(2),
            comm3: item.comm3.toFixed(2),
            stamp: item.stamp.toFixed(2),
            fee: item.fee.toFixed(2),
            tax: item.tax.toFixed(2),
            totSFT: item.totSFT.toFixed(2),
            applyGst: formatYesNo(item.applyGst),
            premGststat: item.premGststat,
            premGstrate: item.premGstrate.toFixed(4),
            premGst: item.premGst.toFixed(2),
            payable: item.payable.toFixed(2),
            itemDesc1: item.itemDesc1,
            itemDesc2: item.itemDesc2,
            itemDesc3: item.itemDesc3,
            itemDesc4: item.itemDesc4,
            itemDesc5: item.itemDesc5
          }
          this.itemList.push(convertItem)
        })
      } else {
        this.itemList = []
      }
      return true
    },
    getExpanded(index) {
      if (index === true) {
        return 'mdi-minus-box'
      } else {
        return 'mdi-plus-box'
      }
    },
    getExpandedColor(index) {
      if (index === true) {
        return 'primary'
      } else {
        return 'red'
      }
    },
    doExpandAll() {
      this.singleExpand = false
      for (let i = 0; i < this.itemList.length; i += 1) {
        const item = this.itemList[i]
        this.expanded.push(item)
      }
    },
    doCollapseAll() {
      this.singleExpand = true
      this.expanded = []
    }
  },
  mounted() {
    if (this.$store.state.underwriting.policySummarySettings.init !== 1) {
      this.$store.dispatch('policySummaryInit')
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policySummarySettings.init !== 1) {
      this.$store.dispatch('policySummaryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  components: {
    QueryPolicyTotals,
    QueryAdditionalSettings,
    QuerySumInsuredTotals,
    ButtonPrintSchedule
  },
  mixins: [MessageMixin, listPolicyMixin]
}
</script>

<style lang="scss" scoped>
.infoField {
  line-height: 2em;
  .infoLabel {
    vertical-align: middle;
    display: inline-block;
    width: 150px;
  }
}
</style>
